
import * as CryptoJS from "crypto-js";

export function checkAccessSinglePage(action: string, authUser: any){
    try{
        if(authUser.role_id == 1){
            return true
        }
        const findIndex = authUser.rolesArr.findIndex(obj => obj.permission_key === action)
        if(findIndex == 0 || (findIndex && findIndex!='-1')){
            return true
        }else{
            return false
        }
    }catch(err){
        return false
    }
}

export function generateSlug(str: string){
    try{
        return str
        .trim()                      // remove whitespaces at the start and end of string
        .toLowerCase()              
        .replace(/^-+/g, "")         // remove one or more dash at the start of the string
        .replace(/[^\w-]+/g, "-")    // convert any on-alphanumeric character to a dash
        .replace(/-+/g, "-")         // convert consecutive dashes to singuar one
        .replace(/-+$/g, "")
    }catch(err){
        console.log("err")
    }
}
export function validURL(str: string){
    const pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
      '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    return !!pattern.test(str);
  }

  // Capitalize the first letter of each word in a string
export function capitalizeFirstOfEveryWord(str) {
    const arr = str.split(" ");
    //loop through each element of the array and capitalize the first letter.
    for (let i = 0; i < arr.length; i++) {
      arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    }
  
    let result = ''
    for (let i = 0; i < arr.length; i++) {
      result = result +' '+ arr[i];
    }
  
    return result
  }

  
export function encrypt(src) {
    const passphrase = "ALAA573";
    return CryptoJS.AES.encrypt(src, passphrase).toString();
  }
  
  export function decrypt(src) {
    const passphrase = "ALAA573";
    const bytes = CryptoJS.AES.decrypt(src, passphrase);
    const originalText = bytes.toString(CryptoJS.enc.Utf8);
    return originalText;
  }
 
  
  export function toUtcDateTime(d){
    return new Date(d).toISOString().replace('T', ' ').split(".")[0]
  }
  

  export function copyToClipboardUsingTextarea(text) {
    // Create a hidden textarea element
    const textarea = document.createElement('textarea')
  
    // Set the value of the textarea to the text you want to copy
    textarea.value = text
  
    // Ensure the textarea is not visible
    textarea.style.position = 'absolute'
    textarea.style.left = '-9999px' // Position off-screen to keep it hidden
    document.body.appendChild(textarea) // Append it to the body
  
    // Select the text in the textarea
    textarea.select()
    textarea.setSelectionRange(0, textarea.value.length) // For mobile devices
  
    // Try to copy the selected text to the clipboard
    try {
      const successful = document.execCommand('copy') // This will copy the text
      document.body.removeChild(textarea) // Clean up by removing the textarea
      return successful // Return whether the copy was successful
    } catch (err) {
      document.body.removeChild(textarea) // Clean up if there was an error
      console.error('Failed to copy text:', err)
      return false
    }
    }

 export function downloadFile(file: File) {
      const url = URL.createObjectURL(file);
      const a = document.createElement('a');
      a.href = url;
      a.download = file.name; // The name of the file to download
      document.body.appendChild(a);
      a.click(); // Programmatically click the link to trigger download
      document.body.removeChild(a); // Remove the link after download
      URL.revokeObjectURL(url); // Clean up the URL object
}

export function isMacDesktop(): boolean {
  const ua = navigator.userAgent ?? '';
  const platform = navigator.platform ?? '';

  // UA-CH (Chromium only) — optional and runtime-safe
  const uaDataPlatform =
    (('userAgentData' in navigator) && (navigator as any).userAgentData?.platform) || '';

  const isMacPlatform =
    /mac/i.test(uaDataPlatform) ||          // e.g. "macOS" (Chromium only)
    /mac/i.test(platform) ||                // e.g. "MacIntel"
    /Macintosh|Mac OS X/.test(ua);          // UA fallback

  const isIOSClassic = /iPhone|iPod|iPad/.test(ua);

  // iPadOS desktop mode: UA says "Macintosh" but device is touch-capable
  const isIPadOSDesktopMode = /Macintosh/.test(ua) && (navigator.maxTouchPoints ?? 0) > 1;

  return isMacPlatform && !isIOSClassic && !isIPadOSDesktopMode;
}

export function shuffle(array) {
  if (!Array.isArray(array)) return [];
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}
  
export function formatTimePlan_(obj,days,hours,minutes) {
  let str = ''
  if(obj?.days>0){
      str+=`${obj?.days}${days}`
      if(obj?.hours>0) {
          str+=`, ${obj?.hours}${hours}`
          if(obj?.minutes>0){
              str+=`, ${obj?.minutes}${minutes}`
              return str
          }else{
              return str
          }
      }else{
          if(obj?.minutes>0){
              str+=`, ${obj?.minutes}${minutes}`
              return str
          }else{
              return str
          }
      }
  }else {
      if(obj?.hours>0) {
          str+=`${obj?.hours}${hours}`
          if(obj.minutes>0){
              str+=`, ${obj?.minutes}${minutes}`
              return str
          }else{
              return str
          }
      }else{
          if(obj?.minutes>0){
              str+=`${obj?.minutes}${minutes}`
              return str
          }else{
              return str
          }
      }
  }
} 

const nav = typeof navigator !== "undefined" ? navigator : undefined;

type UAData = { platform?: string; mobile?: boolean };
const uaData: UAData | undefined =
  nav && "userAgentData" in nav ? (nav as any).userAgentData : undefined;

const UA   = nav?.userAgent  ?? "";
const PLAT = nav?.platform   ?? "";

// Android
export function isAndroid() {
  return uaData?.platform?.toLowerCase().includes("android") ?? /Android/i.test(UA);
}

// iOS / iPadOS
export function isIOS() {
  const iOSUA  = /iPhone|iPad|iPod/i.test(UA);
  const iPadOS = !iOSUA && /Mac/i.test(PLAT) && (nav?.maxTouchPoints ?? 0) > 1;
  return iOSUA || iPadOS;
}

// Windows
export function isWindows() {
  return uaData?.platform === "Windows" || /Win(dows )?NT|Windows/i.test(UA);
}

// Any desktop computer (not Android/iOS)
export function isComputer() {
  if (isAndroid() || isIOS()) return false;
  if (uaData?.mobile !== undefined) return !uaData.mobile;
  return /Win|Mac|Linux|X11|CrOS/i.test(UA);
}

export function toHttpsAbsolute(input: string | null | undefined, base?: string): string | null {
  if(location.protocol === 'http:') return input as (string | null)
  if (!input) return null;
  let s = String(input).trim();

  // leave data/blob as-is
  if (/^(data|blob):/i.test(s)) return s;

  // protocol-relative -> force https
  if (/^\/\//.test(s)) return 'https:' + s;

  // bare host -> add https
  if (/^www\./i.test(s)) return 'https://' + s;

  // http -> upgrade to https
  if (/^http:\/\//i.test(s)) s = s.replace(/^http:/i, 'https:');

  try {
    const origin = base ?? (typeof location !== 'undefined' ? location.origin : undefined);
    const u = origin ? new URL(s, origin) : new URL(s); // handles absolute or relative
    if (u.protocol === 'http:') u.protocol = 'https:';  // final safety
    return u.toString();
  } catch {
    return null; // invalid URL and no base to resolve
  }
}